import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "@/helpers/axios";
import type { ApiResponse } from "@/helpers/axios";
import type { ApiDevice } from "../_types/devices.types";

export type CreateDevicePayload = {
  name: string;
  deviceType: string;
  location?: string;
  organization?: string;
  assignedTo?: string;
  notes?: string;
  deviceProfileId?: string | null;
  deviceBrandingId?: string | null;
};

type CreateDeviceResponse = ApiDevice & { enrollmentCode: string };

export const useCreateDeviceMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: CreateDevicePayload) => {
      const response = await axiosInstance.post<
        ApiResponse<CreateDeviceResponse>
      >("/v2/devices", payload);
      if (!response.data.success || !response.data.data) {
        throw new Error(response.data.message ?? "Failed to create device");
      }
      return response.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["devices"] });
    },
  });
};
